export default function setDocumentScroll(position) {
    window.document.documentElement.scrollTop = position;
    window.document.body.scrollTop = position;
}
